import { PrimaryButton, useModal } from "@shape-ds/components";
import React from "react";
import FlagIcon from "@mui/icons-material/Flag";
import { useFeatureFlag } from "../FeatureFlag.context";
import FeatureFlagModal from "./FeatureFlagModal";
import "./style.scss";

const FeatureFlagButton: React.FC = () => {
  const { openModal } = useModal();
  const showFeatureFlagButton = Boolean(useFeatureFlag("ff-manager"));
  if (!showFeatureFlagButton) return null;

  return (
    <PrimaryButton
      startIcon={<FlagIcon />}
      data-testid="ff-button"
      className="ff-button"
      onClick={() =>
        openModal(<FeatureFlagModal />, { title: "Feature Flag Manager" })
      }
    />
  );
};

export default FeatureFlagButton;
